import React, { useState, useEffect } from 'react';
import {v4 as uuidV4} from 'uuid';

import Data from '../data/daimlerLtm.json'

const countries = Data.map((data) => data.Country);

const SELECT_COUNTRY = 'SELECT COUNTRY';
const SELECT_DEALERSHIP = 'SELECT DEALERSHIP';

let uniqueCountries = [...new Set(countries)].sort();
uniqueCountries = [SELECT_COUNTRY, ...uniqueCountries];

export default function FormUs () {

    const [country , setCountry] = useState('');

    const [dealerships, setDealerships] = useState([]);
    const [dealership , setDealership] = useState('');
    const [dealershipCode, setDealershipCode] = useState('');

    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');

    const [formSuccess, setFormSuccess] = useState(false);
    const [formError, setFormError] = useState(false);
    const [emailError, setEmailError] = useState(false);

    const [newForm, setNewform] = useState(false);

    const clearUserInformation = () => {
        setFirstName('');
        setLastName('');
        setEmail('');
    }

    const clearAll = () => {
        clearUserInformation();
        setCountry(SELECT_COUNTRY)
        setDealerships([]);
        setDealership('');
        setDealershipCode('');
        setFormError(false);
        setFormSuccess(false);
        setNewform(false);
    }
    
    const validEmail = (e) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const email = e.target.value;

        const validEmail = re.test(email);

        if (!validEmail) {
            setEmailError(true);
            setFormError(true);
        } else {
            setEmailError(false);
            setFormError(false);
        }
    }
    
    const handleEmail = (e) => {
        setEmail(e.target.value.toUpperCase());
    }

    const handleFirstName = (e) => {
        setFirstName(e.target.value.toUpperCase());
    }

    const handleLastName = (e) => {
        setLastName(e.target.value.toUpperCase());
    }

    const handleNewForm = () => {
        clearAll();
    }

    const handleNewFormKeepDealership = () => {
        clearUserInformation();
        setFormError(false);
        setFormSuccess(false);
        setNewform(false);
    }

    const handleCountryChange = (e) => {
        if (e.target.value === SELECT_COUNTRY) {
            setCountry('');
            setDealership('');
            clearUserInformation();
        }
        setCountry(e.target.value);
    }

    const handleDealershipChange = (e)=>{
        setDealership(e.target.value);
    }

    useEffect(() => {
        let dealershipsData = Data.filter((data) => data.Country === country).map((data) => data.Dealership);
        let uniqueDealerships = [...new Set(dealershipsData)].sort();
        uniqueDealerships = [SELECT_DEALERSHIP, ...uniqueDealerships];
        setDealership(SELECT_DEALERSHIP)
        setDealerships(uniqueDealerships);
    }, [country])

    useEffect(() => {
        const dealershipCodeData = Data.find((data) => data.Country === country && data.Dealership === dealership);
        if (dealershipCodeData) {
            setDealershipCode(dealershipCodeData.Code);
        } else {
            setDealershipCode("-");
        }
    }, [dealership]);

    const handleSubmit = async (e)=>{
        e.preventDefault();

        setNewform(true);
        
        const id = uuidV4();
        const URL = 'https://voywtbkai8.execute-api.sa-east-1.amazonaws.com/dev/newregister';

        const options = {
            method: 'POST',
            mode: 'no-cors',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                uniqueId: id,
                country: country,
                state: country,
                city: country,
                dealership: dealership,
                dealershipCode: dealershipCode,
                email: email,
                firstName: firstName,
                lastName: lastName
            })
        }

        await fetch(URL, options)
            .then((response) => {
                console.log(response);
                setFormSuccess(true);
            })
            .catch(() => setFormError(true));
    }

    return(
        <form onSubmit={(e) => {handleSubmit(e)}}>
            <div className='container'>
                <div className='card-header mb-3'>
                    <h1> DAIMLER TRUCK - PRE REGISTER GAME FORM - ENGLISH </h1>
                </div>
                <div className='container'>
                    <div className="mb-3">
                        <div className="input-group mb-3">
                            <span className="input-group-text"> COUNTRY </span>
                            <select className="form-select " value={country} name="country" onChange={(e) => {handleCountryChange(e)}}>
                                {
                                    uniqueCountries.map((countryMap, index) => <option key={index} value={countryMap}>{countryMap}</option>)
                                }
                            </select>
                        </div>
                    </div>

                    {country && country !== SELECT_COUNTRY 
                    ?
                    <div className="mb-3">
                        <div className="input-group mb-3">
                            <span className="input-group-text"> DEALERSHIP </span>
                            <select className="form-select" value={dealership} name="dealership" onChange={(e) => {handleDealershipChange(e)}}>
                                {
                                    dealerships.map((dealershipMap, index) => <option key={index} value={dealershipMap}>{dealershipMap}</option>)
                                }
                            </select>
                        </div>
                    </div>
                    :''}
                </div>
                
                { dealership && dealership !== SELECT_DEALERSHIP && country !== SELECT_COUNTRY 
                ? 
                <div className='container'>
                    <div className="row">
                        <div className="input-group mb-3 form-group">
                            <label  className="input-group-text"> DEALERSHIP CODE </label>
                            <input className="form-control text-center" type='text' name='dealershipCode' value={dealershipCode}disabled/>
                        </div>
                    </div>

                    <div className="mb-3">
                        <div className="row">
                            <div className="input-group mb-3">
                                <span className="input-group-text"> E-MAIL </span>
                                <input className="form-control" type='text' name='email' value={email} onChange={(e) => {handleEmail(e)}} onBlur = {(e) => {validEmail(e)}}/>
                            </div>
                        </div>

                        <div className="row">
                            <div className="input-group mb-3">
                                <span className="input-group-text"> FIRST NAME </span>
                                <input className="form-control" type='text' name='firstName' value={firstName} onChange={(e) => {handleFirstName(e)}}/>
                            </div>
                            <div className="input-group mb-3">
                                <span className="input-group-text"> LAST NAME </span>
                                <input className="form-control" type='text' name='lastName' value={lastName} onChange={(e) => {handleLastName(e)}}/>
                            </div>
                        </div>
                    </div>
                </div>
                : '' }
                <div className='container  mx-auto style={{"width": "200px"}}'>
                    {
                        newForm ?
                        <div>
                            <button className="btn btn-primary mb-3" type='button' onClick={(e) => {handleNewFormKeepDealership(e)} } >NEW REGISTER (KEEPING DEALERSHIP)</button>
                            <button className="btn btn-secondary mb-3 ms-3" type='button' onClick={(e) => {handleNewForm(e)} } >NEW REGISTER</button>
                        </div>
                        
                        :
                        country && country !== SELECT_COUNTRY &&
                        dealership && dealership !== SELECT_DEALERSHIP &&
                        email !== '' &&
                        firstName !== '' &&
                        lastName !== ''
                        ?
                        <button className="btn btn-success mb-3" type='button' onClick={(e) => {handleSubmit(e)} }>SUBMIT</button>                        
                        :
                        <button className="btn btn-secondary mb-3" type='button' disabled>SUBMIT</button>
                    }
                </div>
                <div className='container'>
                    {
                        formSuccess ? <div className="alert alert-success" role="alert"> REGISTERED WITH SUCCESS! </div> : ''
                    }
                    {
                        formError ? <div className="alert alert-danger" role="alert"> ERROR! PLEASE CHECK YOUR INFORMATION! </div> : ''
                    }
                    {
                        emailError ? <div className="alert alert-danger" role="alert"> YOUR EMAIL IS INCORRECT, PLEASE CHECK! </div> : ''
                    }
                </div>
            </div>
        </form>
    )
};
